import script from "./PaginaSucesso.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginaSucesso.vue?vue&type=script&setup=true&lang=js"

import "./PaginaSucesso.vue?vue&type=style&index=0&id=af93f190&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af93f190"]])

export default __exports__